import { getConfig } from '../utils';

export function errorHandler(error) {
  if (!error.success) {
    if (error.error === 'You are not signed in') return (window.location.href = getConfig().REDIRECTION_URL);
  } else {
    return null;
  }
}
